// Translations for Hayalan Coffee — Bahasa Indonesia & English
export const translations = {
  id: {
    nav: {
      home: "Beranda",
      about: "Tentang Kami",
      menu: "Menu",
      gallery: "Galeri",
      contact: "Kontak",
      booking: "Booking VIP",
    },
    hero: {
      eyebrow: "Coffee Shop Premium • Pangkalpinang",
      title_1: "Masuk ke",
      title_2: "Dunia Hayalan,",
      title_3: "Nikmati Kopi dengan Cerita.",
      subtitle:
        "Tempat ngopi dengan rasa premium, suasana nyaman, dan pengalaman yang tak terlupakan.",
      cta_menu: "Lihat Menu",
      cta_booking: "Booking Ruangan VIP",
      stat_rating: "Rating Pelanggan",
      stat_menu: "Pilihan Menu",
      stat_hours: "Buka Setiap Hari",
    },
    about: {
      eyebrow: "Tentang Hayalan Coffee",
      title: "Lebih dari sekadar secangkir kopi —\nini ruang untuk berhayal.",
      p1: "Hayalan Coffee adalah coffee shop premium di Pangkalpinang yang dirancang untuk menjadi tempat ngopi, kerja, meeting, dan quality time yang berkesan. Kami percaya setiap cangkir punya cerita, dan setiap sudut ruangan punya tempat untuk hayalanmu.",
      p2: "Dari biji kopi pilihan, suasana hangat, sampai ruangan VIP yang bisa dibooking — kami menyajikan pengalaman yang lebih dari sekadar kopi.",
      bullets: [
        "Area indoor nyaman & ber-AC",
        "Layanan dine-in dan takeaway",
        "VIP / Meeting room siap booking",
        "Banyak spot foto estetik",
      ],
    },
    features: {
      eyebrow: "Kenapa Hayalan",
      title: "Lima alasan kamu akan kembali.",
      items: [
        {
          title: "Kopi Berkualitas",
          desc: "Biji Arabika pilihan diseduh barista berpengalaman, setiap hari.",
        },
        {
          title: "Spot Foto Estetik",
          desc: "Setiap sudut dirancang Instagrammable, dari pagi sampai malam.",
        },
        {
          title: "VIP Meeting Room",
          desc: "Ruangan privat ber-AC, cocok untuk meeting atau acara kecil.",
        },
        {
          title: "Area Indoor & Outdoor",
          desc: "Nyaman siang hari, hangat saat malam. Pilih sesuai mood-mu.",
        },
        {
          title: "Bisa Takeaway",
          desc: "Buru-buru? Pesan dan bawa pulang dalam hitungan menit.",
        },
      ],
    },
    featured: {
      eyebrow: "Menu Pilihan",
      title: "Signature dari hati Hayalan.",
      subtitle:
        "Racikan favorit pelanggan yang paling sering kembali untuk dipesan lagi.",
      cta: "Lihat Menu Lengkap",
      from: "Mulai dari",
    },
    gallery: {
      eyebrow: "Galeri",
      title: "Momen di Hayalan.",
      subtitle:
        "Dari secangkir latte hangat sampai sudut foto yang viral — setiap kunjungan punya ceritanya.",
    },
    testimonials: {
      eyebrow: "Apa Kata Pelanggan",
      title: "Rating 4.7/5 dari ratusan pelanggan.",
      items: [
        {
          quote: "Pelayanan hangat dan banyak spot foto keren.",
          name: "Dini Pratiwi",
          role: "Content Creator",
        },
        {
          quote:
            "Ruangan indoor nyaman meskipun siang hari, AC sejuk dan tempat duduknya luas.",
          name: "Rahman Hidayat",
          role: "Mahasiswa",
        },
        {
          quote:
            "VIP room bisa booking untuk acara atau meeting — recommended untuk meeting kantor.",
          name: "Sari Wulandari",
          role: "HR Manager",
        },
        {
          quote: "Cookies sangat recommended, kopinya pas, harganya juga ramah.",
          name: "Budi Santoso",
          role: "Pecinta Kopi",
        },
      ],
    },
    contact: {
      eyebrow: "Kunjungi Kami",
      title: "Mampir, atau kabari kami dulu.",
      address_label: "Alamat",
      address:
        "Jl. Kapten Sulaiman Arief No.170, Pangkalpinang, Bangka Belitung",
      phone_label: "Telepon / WhatsApp",
      phone: "0851-9150-0909",
      hours_label: "Jam Operasional",
      hours: "Buka setiap hari · sampai pukul 22.00 WIB",
      cta_directions: "Buka di Google Maps",
      cta_whatsapp: "Chat via WhatsApp",
    },
    booking: {
      title: "Booking VIP Meeting Room",
      subtitle:
        "Isi singkat, kami balas via WhatsApp dalam beberapa menit.",
      name: "Nama Lengkap",
      phone: "Nomor WhatsApp",
      date: "Tanggal",
      time: "Jam",
      guests: "Jumlah Tamu",
      notes: "Catatan (opsional)",
      submit: "Kirim ke WhatsApp",
      cancel: "Batal",
      success: "Membuka WhatsApp...",
    },
    cart: {
      title: "Pesananmu",
      empty_title: "Keranjang masih kosong",
      empty_subtitle: "Tap ikon + di samping menu untuk menambah pesanan.",
      add: "Tambah",
      total: "Total",
      checkout: "Pesan via WhatsApp",
      clear: "Kosongkan",
      view: "Lihat Pesanan",
      item: "item",
      items: "item",
      note_label: "Catatan untuk barista",
      note_placeholder: "Less ice, less sugar, nama untuk cup...",
      pickup_label: "Tipe Pesanan",
      dinein: "Dine-in",
      takeaway: "Takeaway",
      added: "ditambahkan",
      added_to_cart: "ditambahkan ke keranjang",
    },
    footer: {
      tagline:
        "Coffee shop premium di Pangkalpinang. Tempat untuk berhayal, ngopi, dan berbagi cerita.",
      quick: "Navigasi",
      contact: "Kontak",
      follow: "Ikuti Kami",
      rights: "Hak cipta dilindungi.",
    },
    menuPage: {
      eyebrow: "Menu Lengkap",
      title: "Setiap rasa, sebuah hayalan.",
      subtitle:
        "Harga dalam ribuan Rupiah (k). Hot & Ice tersedia untuk varian tertentu.",
      back: "Kembali ke Beranda",
      hot: "HOT",
      ice: "ICE",
      signature_pick: "Pilihan Signature",
      categories: {
        all: "Semua",
        hayalan: "Hayalan Series",
        arabica: "Arabica Series",
        noncoffee: "Non-Coffee",
        mocktail: "Mocktail",
        tea: "Tea Series",
        signature: "Signature",
      },
      search_placeholder: "Cari menu...",
      empty_title: "Menu tidak ditemukan.",
      empty_subtitle: "Coba kata kunci lain atau pilih kategori berbeda.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      menu: "Menu",
      gallery: "Gallery",
      contact: "Contact",
      booking: "Book VIP",
    },
    hero: {
      eyebrow: "Premium Coffee Shop • Pangkalpinang",
      title_1: "Step into",
      title_2: "the world of Hayalan,",
      title_3: "savor coffee with a story.",
      subtitle:
        "A coffee place with premium flavor, cozy atmosphere, and an unforgettable experience.",
      cta_menu: "View Menu",
      cta_booking: "Book VIP Room",
      stat_rating: "Customer Rating",
      stat_menu: "Menu Choices",
      stat_hours: "Open Every Day",
    },
    about: {
      eyebrow: "About Hayalan Coffee",
      title: "More than a cup of coffee —\nit's a space to dream.",
      p1: "Hayalan Coffee is a premium coffee shop in Pangkalpinang, designed to be a place for coffee, work, meetings, and memorable quality time. We believe every cup has a story, and every corner has room for your imagination.",
      p2: "From selected beans and warm ambience to a bookable VIP room — we serve an experience that goes far beyond coffee.",
      bullets: [
        "Cozy air-conditioned indoor area",
        "Dine-in and takeaway service",
        "Bookable VIP / meeting room",
        "Plenty of aesthetic photo spots",
      ],
    },
    features: {
      eyebrow: "Why Hayalan",
      title: "Five reasons you'll come back.",
      items: [
        {
          title: "Quality Coffee",
          desc: "Selected Arabica beans, brewed daily by experienced baristas.",
        },
        {
          title: "Aesthetic Photo Spots",
          desc: "Every corner is built to be Instagrammable, morning to night.",
        },
        {
          title: "VIP Meeting Room",
          desc: "A private, air-conditioned room — perfect for meetings or small events.",
        },
        {
          title: "Indoor & Outdoor",
          desc: "Cool by day, warm by night. Pick the spot that fits your mood.",
        },
        {
          title: "Takeaway Friendly",
          desc: "In a rush? Order and pick up within minutes.",
        },
      ],
    },
    featured: {
      eyebrow: "Featured Menu",
      title: "Signatures from the heart of Hayalan.",
      subtitle:
        "Customer favorites that keep guests coming back for another sip.",
      cta: "See Full Menu",
      from: "From",
    },
    gallery: {
      eyebrow: "Gallery",
      title: "Moments at Hayalan.",
      subtitle:
        "From a warm latte to a viral photo corner — every visit has its own story.",
    },
    testimonials: {
      eyebrow: "What Guests Say",
      title: "Rated 4.7/5 by hundreds of guests.",
      items: [
        {
          quote: "Warm service and so many cool photo spots.",
          name: "Dini Pratiwi",
          role: "Content Creator",
        },
        {
          quote:
            "The indoor area is cozy even in the afternoon — cool AC and roomy seating.",
          name: "Rahman Hidayat",
          role: "Student",
        },
        {
          quote:
            "VIP room is bookable for events or meetings — highly recommended for office meetups.",
          name: "Sari Wulandari",
          role: "HR Manager",
        },
        {
          quote: "Cookies are highly recommended, coffee is on point, and the price is fair.",
          name: "Budi Santoso",
          role: "Coffee Lover",
        },
      ],
    },
    contact: {
      eyebrow: "Visit Us",
      title: "Drop by, or message us first.",
      address_label: "Address",
      address:
        "Jl. Kapten Sulaiman Arief No.170, Pangkalpinang, Bangka Belitung",
      phone_label: "Phone / WhatsApp",
      phone: "0851-9150-0909",
      hours_label: "Opening Hours",
      hours: "Open daily · until 10:00 PM WIB",
      cta_directions: "Open in Google Maps",
      cta_whatsapp: "Chat on WhatsApp",
    },
    booking: {
      title: "Book the VIP Meeting Room",
      subtitle: "Fill in briefly — we'll reply on WhatsApp within minutes.",
      name: "Full Name",
      phone: "WhatsApp Number",
      date: "Date",
      time: "Time",
      guests: "Number of Guests",
      notes: "Notes (optional)",
      submit: "Send to WhatsApp",
      cancel: "Cancel",
      success: "Opening WhatsApp...",
    },
    cart: {
      title: "Your Order",
      empty_title: "Your cart is empty",
      empty_subtitle: "Tap the + icon next to a menu item to add it.",
      add: "Add",
      total: "Total",
      checkout: "Order via WhatsApp",
      clear: "Clear",
      view: "View Order",
      item: "item",
      items: "items",
      note_label: "Note for the barista",
      note_placeholder: "Less ice, less sugar, name on cup...",
      pickup_label: "Order Type",
      dinein: "Dine-in",
      takeaway: "Takeaway",
      added: "added",
      added_to_cart: "added to cart",
    },
    footer: {
      tagline:
        "A premium coffee shop in Pangkalpinang. A space to dream, sip, and share stories.",
      quick: "Quick Links",
      contact: "Contact",
      follow: "Follow Us",
      rights: "All rights reserved.",
    },
    menuPage: {
      eyebrow: "Full Menu",
      title: "Every flavor, a daydream.",
      subtitle:
        "Prices in thousands of Rupiah (k). Hot & Ice are available on selected items.",
      back: "Back to Home",
      hot: "HOT",
      ice: "ICE",
      signature_pick: "Signature Pick",
      categories: {
        all: "All",
        hayalan: "Hayalan Series",
        arabica: "Arabica Series",
        noncoffee: "Non-Coffee",
        mocktail: "Mocktail",
        tea: "Tea Series",
        signature: "Signature",
      },
      search_placeholder: "Search menu...",
      empty_title: "No menu found.",
      empty_subtitle: "Try another keyword or pick a different category.",
    },
  },
};
